import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { masterService } from "../api/masterService";
import { useNotification } from "../contexts/NotificationContext";

export default function AddSatuanModal({
  isOpen,
  onClose,
  initialData,
  onSuccess,
}) {
  // Form States
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { showSuccess, showError } = useNotification();

  useEffect(() => {
    if (isOpen && initialData) {
      setName(initialData.name || "");
    } else if (isOpen) {
      // Reset form
      setName("");
      setError("");
    }
  }, [isOpen, initialData]);

  const handleSubmit = async () => {
    if (!name.trim()) {
      setError("Nama satuan harus diisi");
      return;
    }

    setLoading(true);
    setError("");

    try {
      if (initialData?.id) {
        await masterService.units.update(initialData.id, { name: name.trim() });
        showSuccess("Satuan berhasil diperbarui");
      } else {
        await masterService.units.create({ name: name.trim() });
        showSuccess("Satuan berhasil ditambahkan");
      }

      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      console.error("Error saving satuan:", err);
      const errMsg = err.message || "Gagal menyimpan data";
      setError(errMsg);
      showError(errMsg);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4 modal-backdrop-enter">
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl ring-1 ring-slate-200/70 shadow-2xl w-full max-w-lg flex flex-col max-h-[90vh] overflow-hidden modal-panel-enter">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 bg-teal-600 text-white rounded-t-2xl">
          <h2 className="text-base font-semibold tracking-tight">
            {initialData ? "Edit Data Satuan" : "Tambah Data Satuan"}
          </h2>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4 overflow-y-auto">
          {error && (
            <div className="p-3 bg-rose-50 ring-1 ring-rose-200 text-rose-700 rounded-lg text-sm">
              {error}
            </div>
          )}

          <div>
            <label className="block text-xs font-medium text-slate-600 mb-1.5">
              Nama Satuan <span className="text-rose-500">*</span>
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent focus:bg-white transition-colors"
              placeholder="Contoh: Unit"
              disabled={loading}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-slate-100 bg-slate-50/40 rounded-b-2xl flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={loading}
            className="px-5 py-2 bg-white ring-1 ring-slate-200 text-slate-700 rounded-lg hover:bg-slate-50 font-medium text-sm transition-colors disabled:opacity-50">
            Batal
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-5 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 font-medium text-sm transition-colors shadow-sm shadow-teal-600/20 disabled:opacity-50">
            {loading ? "Menyimpan..." : "Simpan Data"}
          </button>
        </div>
      </div>
    </div>
  );
}
